import React from 'react'
import DetailCard from '../Main/DetailCard'

const value = {
  id: 1,
  heading: "Paper Roller Handling",
  intro : [
    "Paper Roller Handling is a great",
  ],
  features: [
    "Improved Safety: Automatic activation of self-adjusting stabilizers when lifting loads higher than 400 mm for maximum stability.",
    "Stability: Extra-long front legs increase the, Stability when handling unevenly loaded pallets. When lifting height below 400 mm, it is an easy to move as a pallet truck, above 400 mm the truck is automatically locked by triggering the supports at both sides of the steering wheels.",
  ],
  imageUrl: "/images/paper-roller-handling.jpg"
}
const PaperRollerHandling = () => {
  return (
  <>
  <DetailCard lists={value} />
  </>
  )
}

export default PaperRollerHandling